import { IDetailsSidebarStore, SidebarOpenMode } from './detailsSidebar.interface';

export const detailsSidebarInitialState: IDetailsSidebarStore = {
  mode: SidebarOpenMode.None,
};
